import { Stack } from '@mui/material';

import Repl from './components/Repl';

const App = () => {
  return (
    <Stack justifyItems={'center'}>
      <Repl />
    </Stack>
  );
};

export default App;
